import React from 'react';

import RenderBookingConfirmation from './RenderBookingConfirmation/RenderBookingConfirmation';

function Thankyoupage({ match, history, t }) {
  return (
    <div className="home-thankyou-page">
      <RenderBookingConfirmation
        status={match.params && match.params.status}
        pnrNumber={match.params && match.params.pnrNumber}
        history={history}
        t={t}
      />
    </div>
  );
}

export default Thankyoupage;



// WEBPACK FOOTER //
// ./src/features/home/ThankYouPage/ThankyouPage.js